module.exports = __webpack_public_path__ + "img/cancel_action.d73b477d.svg";